import { animate } from "./animate";

export function animationHandler({
  scrollStartX,
  target,
  handleSetAnimationFrame,
  handleSetStartX,
  scrollToX,
}: {
  scrollStartX: number;
  target: HTMLElement;
  scrollToX: number;
  handleSetAnimationFrame: (animationFrame: number) => void;
  handleSetStartX: (scrollLeft: number) => void;
}) {
  return () => {
    animate({
      obj: target,
      endX: scrollToX,
      startX: scrollStartX,
      handleSetAnimationFrame,
      handleSetStartX,
    });
  };
}

export function animationHandlerForClickEvents({
  scrollStartX,
  target,
  handleSetAnimationFrame,
  handleSetStartX,
  scrollToX,
}: {
  scrollStartX: number;
  target: HTMLElement;
  scrollToX: number;
  handleSetAnimationFrame: (animationFrame: number) => void;
  handleSetStartX: (scrollLeft: number) => void;
}) {
  return () => {
    animate({
      obj: target,
      endX: scrollToX,
      startX: scrollStartX,
      handleSetAnimationFrame,
      handleSetStartX,
    });
  };
}
